import type { DefaultizedPieValueType } from "@mui/x-charts/models";

import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";

import { useGetDeliveryStatusStatsQuery } from "@/libs/generated/hooks";
import { DeliveryStatus } from "@/types/models/delivery.types";

const sizing = {
  margin: { right: 5 },
  height: 400, // Increased height for better visibility
  width: 400, // Increased width for better visibility
};

function CanceledVsCompleted() {
  const { data, isPending } = useGetDeliveryStatusStatsQuery();
  const formattedData = data?.getDeliveryStatusStats?.data?.map((item) => ({
    label: item.x,
    value: item.y,
    color: item.x === DeliveryStatus.COMPLETED ? "#44A189" : "#FF8042",
  }));
  const TOTAL = data?.getDeliveryStatusStats?.total;
  const getArcLabel = (params: DefaultizedPieValueType) => {
    const percent = TOTAL ? params.value / TOTAL : 0;
    return `${(percent * 100).toFixed(0)}%`;
  };

  if (isPending) return <div>Loading...</div>;
  return (
    <PieChart
      series={[
        {
          outerRadius: 150, // Increased from 180 for a larger pie
          data: formattedData ?? [],
          arcLabel: getArcLabel,
        },
      ]}
      sx={{
        [`& .${pieArcLabelClasses.root}`]: {
          fill: "white",
          fontSize: 16, // Increased font size for better readability
        },
      }}
      slotProps={{
        legend: {
          direction: "horizontal",
          position: { vertical: "top", horizontal: "start" },
          sx: { padding: 0 },
        },
      }}
      {...sizing}
    />
  );
}

export default CanceledVsCompleted;
